// Only untouched parser output can follow edits to its Markdown automatically.
export function canRefreshSource(document) {
  return (
    document.sourceOrigin !== 'import' &&
    document.annotationSource === 'pending' &&
    document.macroStatus === 'pending' &&
    !document.units.length &&
    !document.edges.length &&
    document.paragraphs.every(
      (p) => p.provenance === 'pending' && !p.note && !p.display_label && !p.paragraph_representation,
    )
  )
}
